/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PreviewTeamMeetingRequest
 */
export interface PreviewTeamMeetingRequest {
  /**
   *
   * @type {string}
   * @memberof PreviewTeamMeetingRequest
   */
  jamieMeetingId: string;
}

/**
 * Check if a given object implements the PreviewTeamMeetingRequest interface.
 */
export function instanceOfPreviewTeamMeetingRequest(
  value: object,
): value is PreviewTeamMeetingRequest {
  if (!("jamieMeetingId" in value) || value["jamieMeetingId"] === undefined)
    return false;
  return true;
}

export function PreviewTeamMeetingRequestFromJSON(
  json: any,
): PreviewTeamMeetingRequest {
  return PreviewTeamMeetingRequestFromJSONTyped(json, false);
}

export function PreviewTeamMeetingRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PreviewTeamMeetingRequest {
  if (json == null) {
    return json;
  }
  return {
    jamieMeetingId: json["jamieMeetingId"],
  };
}

export function PreviewTeamMeetingRequestToJSON(
  json: any,
): PreviewTeamMeetingRequest {
  return PreviewTeamMeetingRequestToJSONTyped(json, false);
}

export function PreviewTeamMeetingRequestToJSONTyped(
  value?: PreviewTeamMeetingRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    jamieMeetingId: value["jamieMeetingId"],
  };
}
